import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const subscribe = (data) => axios.post(`${API}/subscribe`, data);
export const sendContact = (data) => axios.post(`${API}/contact`, data);

export const JOTFORM_URL =
  "https://form.jotform.com/262043938197061?utm_source=getdialedin&utm_medium=website&utm_campaign=research";

export const SOCIALS = {
  instagram: "https://www.instagram.com/jason.dialed.in.golf?igsh=MW5sZXFvemRsNmJtcw==",
  tiktok: "https://www.tiktok.com/@jason.dialed.in?_r=1&_t=ZN-98PgX0C3nQU",
  facebook: "https://www.facebook.com/share/g/1Em8hSzN2q/",
};

export const CONTACT_EMAIL = "Jason@getdialedin.golf";
